import { InputCheck } from './types';

const inputCheckTheme: InputCheck = {
	borderRadius: {
		checkbox: '2px',
		radio: '50%'
	},
	colors: {
		default: 'neutral.600',
		hover: 'neutral.500',
		active: 'primary.500',
		selected: 'primary.500'
	}
};

export default inputCheckTheme;
